module.exports = __webpack_public_path__ + "static/media/santiye_360_logo_white.06f96551.png";